/* tslint:disable */
/* eslint-disable */
/**
 * gremiumhub
 * A platform for digital applications, approvals and discussions.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: denis.lugowski@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ContactMessageDto
 */
export interface ContactMessageDto {
    /**
     * Subject of the contact message
     * @type {string}
     * @memberof ContactMessageDto
     */
    subject: string;
    /**
     * HTML body of the contact message
     * @type {string}
     * @memberof ContactMessageDto
     */
    message: string;
}

/**
 * Check if a given object implements the ContactMessageDto interface.
 */
export function instanceOfContactMessageDto(value: object): value is ContactMessageDto {
    if (!('subject' in value) || value['subject'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function ContactMessageDtoFromJSON(json: any): ContactMessageDto {
    return ContactMessageDtoFromJSONTyped(json, false);
}

export function ContactMessageDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactMessageDto {
    if (json == null) {
        return json;
    }
    return {
        
        'subject': json['subject'],
        'message': json['message'],
    };
}

export function ContactMessageDtoToJSON(json: any): ContactMessageDto {
    return ContactMessageDtoToJSONTyped(json, false);
}

export function ContactMessageDtoToJSONTyped(value?: ContactMessageDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'subject': value['subject'],
        'message': value['message'],
    };
}

